<template>
  <div class="ProtocoloConfig">
    <div class="row">
      <div class="col-6">
        <b-card header-class="ProtocoloConfig--cardHeader">
          <template #header>
            <div class="row">
              <div class="col-3">
                <h6 class="mb-0">
                  Ano
                </h6>
              </div>
              <div class="col-6">
                <h6 class="mb-0">
                  Protocolo Atual
                </h6>
              </div>
            </div>
          </template>
          <div>
            <div class="row">
              <div class="col-3">
                <input v-model="config.ano"
                       v-validate="`required`"
                       type="number"
                       placeholder="0000"
                       name="ano_config"
                       :class="{ 'is-invalid': errors.has('ano_config') }"
                       class="form-control form-control-sm">
              </div>
              <div class="col-6">
                <input v-model="config.protocolo_atual"
                       v-validate="`required`"
                       type="number"
                       name="protocolo_atual_config"
                       :class="{ 'is-invalid': errors.has('protocolo_atual_config') }"
                       class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-right">
        <hr class="hr-secondary">
        <button class="btn btn-sm btn-primary"
                @click="saveConfig()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import ProtocoloConfigService from "@/services/Protocolos/ProtocoloConfigService"

  /* components */
  // import ProtocoloConfigForm from "./ProtocoloConfigForm"

  export default {
    name: "ProtocoloConfig",
    data () {
      return {
        config: {
          ano: null,
          protocolo_atual: null
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        try {
          loader ({ active: true, text: 'Carregando configurações de protocolos...' })
          const config = await ProtocoloConfigService.getConfig()
          Object.assign(this.config, {
            ano: config.ano,
            protocolo_atual: config.protocolo_atual,
            id: config.id
          })
        } finally {
          loader ({ active: false, text: '' })
        }
      },
      async saveConfig () {
        try {
          const status = await this.$validator.validate()
          if (!status) return

          loader ({ active: true, text: 'Salvando configuração...' })

          if (this.config.id) {
            await ProtocoloConfigService.update(this.config.id, this.config)
          } else {
            await ProtocoloConfigService.store(this.config)
          }

          objSwal.success.title = 'Configuração salva!'
          objSwal.success.text = ''
          Swal.fire(objSwal.success)
          this.init()
        } catch (e) {
          objSwal.error.title = 'Atenção'
          objSwal.error.text = 'Houve um erro ao salvar configuração, tente novamente'
          Swal.fire(objSwal.error)
        } finally {
          loader ({ active: false })
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../scss/_utilities/exports";

  .ProtocoloConfig {
    &--cardHeader {
      background-color: $sofiaRei-green;
    }
  }
</style>
